import clsx from 'clsx';

type MaterialIconProps = {
  iconName: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
} & React.HTMLAttributes<HTMLSpanElement>;

export function MaterialIcon({ iconName, size = 'md', className, ...props }: MaterialIconProps) {
  const sizeClasses = {
    'icon-sm': size === 'sm',
    'icon-md': size === 'md',
    'icon-lg': size === 'lg',
    'icon-xl': size === 'xl',
  };

  return (
    <span className={clsx('material-symbols-outlined', sizeClasses, className)} {...props}>
      {iconName}
    </span>
  );
}
